import { Suspense, lazy, useEffect } from "react";
import { HeroSection } from "@/components/landing/hero-section";
import { AppLoader } from "@/components/ui/app-loader";

const HomeSections = lazy(() => import("@/components/landing/home-sections"));

export default function HomePage() {
  useEffect(() => {
    // Scroll to top on initial load
    window.scrollTo(0, 0);

    const sectionId = window.location.hash.replace("#", "");
    if (!sectionId) return;

    let attempts = 0;
    let timeoutId: number | null = null;
    let cancelled = false;

    const scrollToSection = () => {
      const section = document.getElementById(sectionId);
      if (!section) return false;

      const navbarOffset = -80;
      const targetTop = section.getBoundingClientRect().top + window.scrollY - navbarOffset;
      window.scrollTo({ top: Math.max(0, targetTop), behavior: "smooth" });
      return true;
    };

    const maxAttempts = 30;

    const tryScroll = () => {
      if (cancelled) return;
      if (scrollToSection()) return;
      if (attempts < maxAttempts) {
        attempts += 1;
        timeoutId = window.setTimeout(tryScroll, 50);
      }
    };

    tryScroll();

    return () => {
      cancelled = true;
      if (timeoutId !== null) {
        window.clearTimeout(timeoutId);
      }
    };
  }, []);

  return (
    <main id="top" className="relative min-h-screen">
      {/*
        BASE LAYOUT IMPLEMENTATION
        See baselayout.md for the canonical structure.

        Hero is FIXED + fullscreen (h-screen), stays in background.
        Content has margin-top: 100vh to start below hero.
        Content has z-index + background to scroll OVER the hero.
      */}

      <HeroSection />
        <Suspense fallback={<AppLoader tone="light" className="hero-viewport-offset min-h-screen" />}>
          <HomeSections />
        </Suspense>
    </main>
  );
}
